import { ProductRepository, CategoryRepository } from "core/repository";
import { Base2Presenter } from "core/presenter";
import { fn } from "util";

class TotalsPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: true,
      resultSet: [],
      totals: {
        stock_count: 0,
        stock_value: 0
      }
    };
  }

  async onStart() {
    this.filters = {
      status: "active",
      stock: "all",
      category: {
        uuid: "",
        name: ""
      }
    };
    this.subscribeTo("sellable/sync", () => this.doLoadResults());
    this.subscribeTo("sellable/delete", () => this.doLoadResults());
    this.doLoadResults();
  }

  async doLoadResults() {
    this.enqueue({ loading: true });

    const repositoryResult = await ProductRepository.getTotals({
      filters: await this.getFilters()
    });

    if (repositoryResult.success) {
      this.enqueue({ totals: repositoryResult.data });
    }

    this.enqueue({ loading: false });
  }

  async getFilters() {
    const currentUser = await this.mRuntime.get("currentUser");
    const repositoryFilters = [
      {
        connector: "AND",
        field: "company_uuid",
        operation: "EQ",
        value: currentUser.company_uuid
      }
    ];

    if (!fn.isBlank(this.filters.category.uuid)) {
      repositoryFilters.push({
        field: "category_uuid",
        operation: "EQ",
        value: this.filters.category.uuid
      });
    }

    if (!fn.isBlank(this.filters.code)) {
      repositoryFilters.push({
        field: "code",
        operation: "LIKE",
        value: this.filters.code
      });
    }

    if (!fn.isBlank(this.filters.name)) {
      repositoryFilters.push({
        field: "name",
        operation: "LIKE",
        value: this.filters.name
      });
    }

    if (this.filters.status !== "all") {
      repositoryFilters.push({
        field: "deleted",
        operation: "EQ",
        value: `${this.filters.status !== "active"}`
      });
    }

    if (this.filters.stock !== "all") {
      const operation = { positive: "GT", zero: "EQ", negative: "LT" }[
        this.filters.stock
      ];
      repositoryFilters.push({ field: "stock_count", operation, value: "0" });
    }

    return repositoryFilters;
  }

  async getCategoriesByName(name) {
    const result = await CategoryRepository.searchByName(name);
    return result.success ? result.data.map(category => category.uuid) : [];
  }

  async onFilterChange(filters) {
    this.filters = filters;
    this.doLoadResults();
  }
}

export default TotalsPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/list/totals/presenter.js